var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopylink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8679 13.4189C11.2974 13.993 11.8453 14.4681 12.4745 14.8119C13.1037 15.1556 13.7994 15.36 14.5146 15.4112C15.2297 15.4625 15.9475 15.3593 16.6193 15.1087C17.291 14.8581 17.901 14.466 18.4079 13.9589L21.4079 10.9589C22.3187 10.0159 22.8227 8.75289 22.8113 7.4419C22.7999 6.13092 22.2741 4.87686 21.347 3.94982C20.42 3.02278 19.1659 2.49693 17.8549 2.48554C16.5439 2.47415 15.2809 2.97812 14.3379 3.88891L12.6179 5.59891",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8679 11.4192C14.4385 10.845 13.8905 10.37 13.2614 10.0262C12.6322 9.68247 11.9364 9.47805 11.2213 9.42684C10.5061 9.37562 9.78832 9.4788 9.11656 9.72939C8.4448 9.97997 7.83479 10.3721 7.32791 10.8792L4.32791 13.8792C3.41712 14.8222 2.91314 16.0852 2.92454 17.3962C2.93593 18.7072 3.46177 19.9612 4.38881 20.8883C5.31585 21.8153 6.56992 22.3411 7.8809 22.3525C9.19188 22.3639 10.4549 21.86 11.3979 20.9492L13.1079 19.2392",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopylink);
export default __webpack_public_path__ + "static/media/copylink.c98577154ebf60fadca968ce5c0564b8.svg";
export { ForwardRef as ReactComponent };